import { Fade } from "./Reveal";

// Arrow glyphs with a trailing U+FE0E (text-presentation selector) so iOS / mobile
// Safari render the plain typographic arrow instead of the colorful emoji variant.
export const ARROW_UR = "↗︎"; // ↗
export const ARROW_R = "→︎"; // →
export const ARROW_UP = "↑︎"; // ↑

/** Numbered editorial section header (e.g. "01  ABOUT  the short version"). */
export function LeadNum({ no, label, right }: { no: string; label: string; right: string }) {
  return (
    <div className="lead-num">
      <span className="no">{no}</span>
      <span className="lbl">{label}</span>
      <span className="lbl-r">{right}</span>
    </div>
  );
}

/** Fade-in pill list of technologies. */
export function Tags({ items, style }: { items: string[]; style?: React.CSSProperties }) {
  return (
    <Fade className="tags" style={style}>
      {items.map((t) => (
        <span className="tag" key={t}>
          {t}
        </span>
      ))}
    </Fade>
  );
}
